<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Faktura</h4>
        <button (click)="onClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-4">
                <img src="assets/dr-logo-print.jpg" width="175" height="80" />
            </div>
        </div>
        <div *ngIf="faktura && officeSettings" class="row">
            <div class="col-8">
                <select *ngIf="!faktura?.godkendt && kunderAdr?.length > 0" class="form-select" value="" (change)="onKunderAdr($event)">
                    <option selected>-- Vælg adresse --</option>
                    <option [value]="0">Standard</option>
                    <option *ngFor="let adr of kunderAdr" [value]="adr.aid">{{ adr.betegnelse }}</option>
                </select>
                <div>{{ faktura.navn1 }}</div>
                <div>{{ faktura.navn2 }}</div>
                <div>{{ faktura.adresse1 }}</div>
                <div *ngIf="faktura.adresse2">{{ faktura.adresse2 }}</div>
                <div>{{ faktura.postnr }} {{ faktura.bynavn }} </div>
                <div>{{ faktura.land }}</div>
            </div>
            <div class="col-4">
                <div>{{ officeSettings.firmanavn }}</div>
                <div>{{ officeSettings.adresse }}</div>
                <div>{{ officeSettings.postnr }} {{ officeSettings.bynavn }}</div>
                <div>Tlf: {{ officeSettings.telefon }}</div>
                <div>CVR: {{ officeSettings.cvr }}</div>
                <ng-container *ngIf="officeSettings?.pengeinstitut">
                    <div>{{ officeSettings.pengeinstitut }}</div>
                    <div>Kundenummer: {{ faktura.kunder.glkundenr }}</div>
                </ng-container>
                <div>Kunde CVR: {{ faktura.kunder.cvr }}</div>
                <div>Fakturanummer: {{ faktura.fakturanr }}</div>
                <div *ngIf="!editFakturaDato" class="d-flex">
                    <div class="invoice-date">Fakturadato: {{ faktura.dato | date:'dd-MM-yyyy' }} <i *ngIf="!faktura?.godkendt" (click)="editFakturaDato = true" class="fa fa-edit text-primary clickable--link invoice-date--hover"></i></div>
                </div>
                <div *ngIf="editFakturaDato" class="d-flex">
                    Fakturadato:&nbsp;
                    <app-date-picker-dk
                        #fatkuraDato
                        [value]="fakturaDatoValue"
                    ></app-date-picker-dk>&nbsp;
                    <i (click)="editFakturaDato = false" class="me-1 fa fa-ban text-danger clickable--link"></i>
                    <i (click)="onSaveDato(fatkuraDato.value, 'dato')" class="me-1 fa fa-floppy-o text-primary clickable--link"></i>
                </div>
                <div *ngIf="!editBetalingsDato" class="d-flex">
                    <div class="invoice-date">Betalingsdato: {{ faktura.betdato | date:'dd-MM-yyyy' }} <i *ngIf="!faktura?.godkendt" (click)="editBetalingsDato = true" class="fa fa-edit text-primary clickable--link invoice-date--hover"></i></div>
                </div>
                <div *ngIf="editBetalingsDato" class="d-flex">
                    Betalingsdato:&nbsp;
                    <app-date-picker-dk
                        #betalingsDato
                        [minDate]="fakturaDatoDateStruct"
                        [value]="betalingsDatoValue"
                    ></app-date-picker-dk>&nbsp;
                    <i (click)="editBetalingsDato = false" class="me-1 fa fa-ban text-danger clickable--link"></i>
                    <i (click)="onSaveDato(betalingsDato.value, 'betdato')" class="me-1 fa fa-floppy-o text-primary clickable--link"></i>
                </div>
            </div>
        </div>

        <div class="row pt-2">
            <div class="col">
                <h1>{{ faktura?.totalbel >= 0 ? 'Faktura' : 'Kreditnota' }} {{ faktura?.fakturanr }}</h1>
            </div>
        </div>
        <div class="row pt-2 fw-bold">
            <div class="col-3">Sag (vises ikke på faktura)</div>
            <div class="col-5">Fakturatekst</div>
            <div class="col-1 text-end">Moms</div>
            <div class="col-2 text-end">Beløb</div>
            <div *ngIf="!faktura?.godkendt" class="col-1 text-end">
                <i class="me-1 fa fa-trash "></i>
                <i class="me-1 fa fa-ban "></i>
                <i class="me-1 fa fa-edit "></i>
            </div>
        </div>

        <app-invoice-record
            *ngFor="let fakturalinje of faktura?.fakturalinjer; trackBy:trackByFakturalinje"
            [fakturaLinje]="fakturalinje"
            [editAllowed]="!faktura?.godkendt"
            [createCases]="createCases"
            [caseName]="caseNames | caseName:fakturalinje.sag"
            (editChange)="onEditFakturalinje($event, fakturalinje.flid)"
            (delete)="onDeleteFakturalinje(fakturalinje.flid)"
            (save)="onUpdateFakturalinje($event)"
        ></app-invoice-record>
        <app-invoice-record
            *ngFor="let newFakturalinje of newFakturalinjer$ | async; index as i"
            [fakturaLinje]="newFakturalinje"
            [edit]="true"
            [createCases]="createCases"
            [caseName]="caseNames | caseName:newFakturalinje.sag"
            (delete)="cancelNewFakturalinje(i)"
            (save)="onCreateFakturalinje(i, $event)"
        ></app-invoice-record>

        <div class="row">
            <div class="col-9"></div>
            <div class="col-2 text-end border-top">{{ faktura?.totalbel | currency:'DKK':'':'1.2-2':'da' }}</div>
            <div class="col-1"></div>
        </div>
        <div class="row">
            <div class="col-9">Moms</div>
            <div class="col-2 text-end">{{ faktura?.momsbel | currency:'DKK':'':'1.2-2':'da' }}</div>
            <div class="col-1"></div>
        </div>
        <div class="row pb-2">
            <div class="col-9">Ialt</div>
            <div class="col-2 text-end border-top border-bottom">{{ faktura?.totalbel + faktura?.momsbel| currency:'DKK':'':'1.2-2':'da' }}</div>
            <div class="col-1"></div>
        </div>
        <div class="row pb-2">
            <div *ngIf="faktura?.valutaKurs !== 1" class="col-12 text-danger">Bemærk: Denne faktura blive dannet i en anden valutakurs. {{ faktura?.valuta }} til kurs {{ faktura?.valutaKurs | currency:'DKK':'':'1.2-2':'da' }}.</div>
        </div>
    </div>

    <div class="modal-footer justify-content-between">
        <div class="btn-toolbar">
            <button *ngIf="!faktura?.godkendt" type="button" class="btn btn-sm btn-success" (click)="addNewFakturalinje()">Tilføj fakturalinje</button>
            <button *ngIf="!faktura?.godkendt" type="button" class="btn btn-sm btn-primary ms-2" (click)="onChangeCurrency()">Skift valutakurs</button>
        </div>
        <div class="btn-toolbar">
            <button *ngIf="!faktura?.godkendt" type="button" class="btn btn-sm btn-primary" (click)="onGodkendFaktura()">Godkend</button>
            <button *ngIf="!faktura?.godkendt" type="button" class="btn btn-sm btn-danger ms-2" (click)="onDeleteFaktura()">Slet</button>
            <button type="button" class="btn btn-sm btn-primary ms-2" (click)="onPdfPreview()">PDF preview</button>
            <button *ngIf="faktura?.godkendt" type="button" class="btn btn-sm btn-primary ms-2" (click)="onSendFaktura()">Send faktura</button>
        </div>
    </div>
</div>
